<p-dialog
  [visible]="visible || false"
  [modal]="true"
  [closable]="false"
  [resizable]="false"
  [draggable]="false"
  class="font-app-regular"
  [style]="{ width: '40rem' }">
  <ng-template pTemplate="header">
    <div class="header-name ml-auto mr-auto p-4 bg-lightest rounded-md w-full">
      <h1 class="white-space-nowrap text-xl flex justify-center font-app-bold text-darkest">
        {{ "resourcesLimits.title" | translate }}
      </h1>
      <button
        pButton
        class="close-dialog bg-white absolute top-2 right-2"
        icon="pi pi-times"
        [rounded]="true"
        (click)="closeDialog()"></button>
    </div>
  </ng-template>

  <div class="flex flex-col items-center">
    <p>{{ "resourcesLimits.heading" | translate }}</p>
    <table class="border-separate border-spacing-x-2 mt-4">
      <tr>
        <th class="border-b-[20px] relative bg-table_header text-white px-4 py-2 w-1/2">
          {{ "resourcesLimits.header.householdComposition" | translate }}
        </th>
        <th class="border-b-[20px] relative bg-table_header text-white px-4 py-2 w-1/2">
          {{ "resourcesLimits.header.resourcesPerYear" | translate }}
        </th>
      </tr>
      <tr *ngFor="let category of householdCategories; let i = index">
        <td [class]="i % 2 === 0 ? 'bg-table_odd px-4 py-3' : 'bg-table_even px-4 py-3'">
          {{ "resourcesLimits.householdCategories." + category | translate }}
        </td>
        <td [class]="i % 2 === 0 ? 'bg-table_odd text-center px-4 py-3' : 'bg-table_even text-center px-4 py-3'">
          {{ "resourcesLimits.limitsByLocation." + productType + "." + category | translate }}
        </td>
      </tr>
    </table>
    <p class="mt-4 text-sm">
      {{ "resourcesLimits.limitationDetails" | translate }}
    </p>
  </div>
</p-dialog>

